import React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import "./header.css";

const Greenbanner = ({ name }) => {
  return (
    <div>
      <Box className="header-image-container">
        <Box component="img" className="header-image" />
        <Typography variant="h4" className="header-title">
          {name}
        </Typography>
      </Box>
    </div>
  );
};

export default Greenbanner;
